import { JsonDiscriminatorValue, JsonObject } from "ta-json";

import DataType from "../data-type";
import { PropertyDefinition } from "../property-definition";

/**
 * DateTime property definition.
 */
@JsonObject()
@JsonDiscriminatorValue(DataType.DateTime)
export class DateTimePropertyDefinition extends PropertyDefinition {
    constructor(name: string, init?: Omit<Partial<DateTimePropertyDefinition>, "name">) {
        super(name, DataType.DateTime);
        Object.assign(this, init);
    }
}
